import { createApp } from 'vue'
import app from './app.vue';
import {getPropsData} from '../../utils/helper-functions'
import commonStore from '../global/common-store';

export default () => {
  document.querySelectorAll('collection-grid').forEach((el) => {
    const propData =  getPropsData(el.closest('section').nextElementSibling);
    createApp(app, {data:propData}).use(commonStore).mount(el);
  })
}